<div class="cmdb-load-container" *ngIf="!isLoadingLabels">
	<div class="button" [ngClass]="{ disabled: isDownloadingTemplate }" (click)="downloadTemplate()">
		{{ labels.lbl_geral_baixar_template
		}}<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isDownloadingTemplate"></cpi-dot-bounce-loading-effect>
	</div>
	<div class="button" [ngClass]="{ disabled: isDownloadingItemTemplate }" (click)="downloadItemsTemplate()">
		{{ labels.lbl_legenda_de_itens_cmdb
		}}<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isDownloadingItemTemplate"></cpi-dot-bounce-loading-effect>
	</div>
	<pcp-import-excel (getExcelJson)="loadCMDB($event)" [isUploadingExcel]="isUploadingLoad" [labels]="labels" [cleanFile]="cleanFile">
	</pcp-import-excel>
</div>

<cpi-dot-bounce-loading-effect class="mt-2 ml-2" [color]="'var(--primary-color-1)'" *ngIf="isLoadingLabels"></cpi-dot-bounce-loading-effect>
